/*
 * @Author: Gaho
 * @Date: 2024-04-23 10:00:35
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-23 13:29:59
 * @Description: 
 */
export interface RoundStatus {
    prediction: number[];
    status: GameStatus;
    difficulty: 1 | 2 | 3;
    level: number | null;
    multi: number;
    step: number;
    rounds: number | null;
    win: boolean;
    winAmount: number;
    hash: string; 
}

export enum GameStatus {
    PLAY = 'play',
    EMPTY = '',
    LOSE = 'lose',
    CASHOUT = 'cashout',
    WIN = 'win',
}


export const towerRulesData = [
    {
        content1: 'GameTower.Rule1',
        constent2: '',
        img: null,
    }
];

export enum BetType {
    StartBet = 0,
    HandsStart = 1,
    CashOut = 2,
}
export const dropDownOptions = [
    {
        value: 1,
        name: 1,
    },
    {
        value: 2,
        name: 2,
    },
    {
        value: 3,
        name: 3,
    },
    {
        value: 4,
        name: 4,
    },
];

const oEmpty = Object.fromEntries(Array(10).fill(1).entries()); 
export const mutiConfigObj = ({ // 引用方需要深拷贝 
    '1': oEmpty,
    '2': oEmpty,
    '3': oEmpty,
    '4': oEmpty,
});

